import { render, staticRenderFns } from "./DataTableOfficeCost.vue?vue&type=template&id=60029bb6&scoped=true"
import script from "./DataTableOfficeCost.vue?vue&type=script&lang=js"
export * from "./DataTableOfficeCost.vue?vue&type=script&lang=js"
import style0 from "./DataTableOfficeCost.vue?vue&type=style&index=0&id=60029bb6&prod&lang=scss"
import style1 from "./DataTableOfficeCost.vue?vue&type=style&index=1&id=60029bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60029bb6",
  null
  
)

export default component.exports